import {
  IAsessmentFlows,
  ISelectWeightStep,
  IWizardStep,
  StrengthAssessmentStep,
} from 'fitbeat.gym-core';
import { EquipmentRequiringInstruction, StrengthRatioForMuscleGroups } from 'fitbeat.models';
import { UserServiceClient } from '../../../api-clients/lib';
import { IAppStore } from '../HomeWorkouts';
export const STRENGTH_ASSESSMENT_CONFIG_SUCCESS = 'STRENGTH_ASSESSMENT_CONFIG_SUCCESS';
export const STRENGTH_ASSESSMENT_CONFIG_REQUEST = 'STRENGTH_ASSESSMENT_CONFIG_REQUEST';
export const STRENGTH_ASSESSMENT_CONFIG_FAILURE = 'STRENGTH_ASSESSMENT_CONFIG_FAILURE';
export const STRENGTH_ASSESSMENT_ANSWERED = 'STRENGTH_ASSESSMENT_ANSWERED';
export const STRENGTH_ASSESSMENT_COMPLETED_SUCCESS = 'STRENGTH_ASSESSMENT_COMPLETED_SUCCESS';
export const STRENGTH_ASSESSMENT_COMPLETED_FAILURE = 'STRENGTH_ASSESSMENT_COMPLETED_FAILURE';
export const STRENGTH_ASSESSMENT_COMPLETED_LOADING = 'STRENGTH_ASSESSMENT_COMPLETED_LOADING';
export const OPEN_SPECIFIC_QUESITONS = 'OPEN_SPECIFIC_QUESITONS';
export const MANUAL_FLOW_SELECTED = 'MANUAL_FLOW_SELECTED';
export const UNIBANDS_FLOW_SELECTED = 'UNIBANDS_FLOW_SELECTED';
export const DUMBBELL_FLOW_SELECTED = 'DUMBBELL_FLOW_SELECTED';

interface IStrengthAssessmentConfigRequest {
  type: typeof STRENGTH_ASSESSMENT_CONFIG_REQUEST;
}
interface IStrengthAssessmentConfigSuccess {
  type: typeof STRENGTH_ASSESSMENT_CONFIG_SUCCESS;
  payload: {
    config: IAsessmentFlows;
  };
}
interface IStrengthAssessmentConfigFailure {
  type: typeof STRENGTH_ASSESSMENT_CONFIG_FAILURE;
}

interface IStrengthAssesssmentAnswered {
  type: typeof STRENGTH_ASSESSMENT_ANSWERED;
  payload: {
    answer: number;
    currentStep: StrengthAssessmentStep;
    equipmentRequiringInstruction?: EquipmentRequiringInstruction,
  };
}
interface IStrengthAssesssmentCompletedLoading {
  type: typeof STRENGTH_ASSESSMENT_COMPLETED_LOADING;
  payload: {
    shouldRefreshSteps?: boolean;
  }
}

interface IStrengthAssesssmentCompletedFailure {
  type: typeof STRENGTH_ASSESSMENT_COMPLETED_FAILURE;
  payload: {
    error: string;
  };
}

interface IStrengthAssesssmentCompletedSuccess {
  type: typeof STRENGTH_ASSESSMENT_COMPLETED_SUCCESS;
  payload: {
    userStrengthRatios: StrengthRatioForMuscleGroups;
  };
}
interface IOneMuscleStrengthAssesssment {
  type: typeof OPEN_SPECIFIC_QUESITONS;
  payload: {
    questionIds: string[];
  };
}
interface IManualStrengthAssesssment {
  type: typeof MANUAL_FLOW_SELECTED;
}

interface IUnibandsStrengthAssesssment {
  type: typeof UNIBANDS_FLOW_SELECTED;
}
interface IDumbbellStrengthAssesssment {
  type: typeof DUMBBELL_FLOW_SELECTED;
}

export type StrengthAssessmentActionTypes =
  | IStrengthAssessmentConfigRequest
  | IStrengthAssesssmentAnswered
  | IStrengthAssesssmentCompletedFailure
  | IStrengthAssesssmentCompletedLoading
  | IStrengthAssesssmentCompletedSuccess
  | IStrengthAssessmentConfigSuccess
  | IStrengthAssessmentConfigFailure
  | IOneMuscleStrengthAssesssment
  | IManualStrengthAssesssment
  | IUnibandsStrengthAssesssment
  | IDumbbellStrengthAssesssment;

export const strengthAssessmentOpened = (
  userServiceClient: UserServiceClient,
) => {
  return async (dispatch) => {
    await refreshStrengthAssessmentConig(dispatch, userServiceClient)
  };
};

const refreshStrengthAssessmentConig = async (
  dispatch: any,
  userServiceClient: UserServiceClient,
) => {
  try {
    dispatch({ type: STRENGTH_ASSESSMENT_CONFIG_REQUEST });
    const stregthAssessmentConfig =
      await userServiceClient.getStrengthAssessmentConfig();
    dispatch({
      type: STRENGTH_ASSESSMENT_CONFIG_SUCCESS,
      payload: { config: stregthAssessmentConfig },
    });
  } catch (e) {
    dispatch({ type: STRENGTH_ASSESSMENT_CONFIG_FAILURE });
  }
};

export const manualFlowSelected = () => {
  return async (dispatch) => {
    dispatch({
      type: MANUAL_FLOW_SELECTED,
    });
  };
};

export const uniBandsFlowSelected = () => {
  return  async (dispatch) => {
    dispatch({
      type: UNIBANDS_FLOW_SELECTED,
    });
  };
};

export const dumbbellFlowSelected = () => {
  return  async (dispatch) => {
    dispatch({
      type: DUMBBELL_FLOW_SELECTED,
    });
  };
};

export const getSubsetOfSteps = (questionIds: string[]) => {
  return (dispatch) => {
    dispatch({
      type: OPEN_SPECIFIC_QUESITONS,
      payload: { questionIds },
    });
  };
};

export const answerStrenghtAssessment = (
  answer: number,
  currentStep: IWizardStep<ISelectWeightStep>,
  equipmentRequiringInstruction?: EquipmentRequiringInstruction,
) => {
  return (dispatch) => {
    dispatch({
      type: STRENGTH_ASSESSMENT_ANSWERED,
      payload: { answer, currentStep, equipmentRequiringInstruction },
    });
  };
};

export const completeStrengthAssessment = (
  userServiceClient: UserServiceClient,
) => {
  return async (dispatch: any, getState: () => IAppStore) => {
    try {
      dispatch({ type: STRENGTH_ASSESSMENT_COMPLETED_LOADING });
      const answers = getState().strengthAssessment.answers;
      const userStrengthRatios = {};
      Object.keys(answers).reduce((acc, cur) => {
        const bodyGroup = answers[cur].primaryMuscleMover;
        userStrengthRatios[bodyGroup] = answers[cur].ratio;
        return userStrengthRatios;
      }, userStrengthRatios);
      await userServiceClient.completeStrengthAssessment(
        userStrengthRatios,
      );
      dispatch({ type: STRENGTH_ASSESSMENT_COMPLETED_SUCCESS, payload: { userStrengthRatios } });
    } catch (e) {
      dispatch({
        type: STRENGTH_ASSESSMENT_COMPLETED_FAILURE,
        payload: {
          error: 'Failed to save assessment results',
        },
      });
    }
  };
};

export const saveManualStrengthAssessment = (
  userServiceClient: UserServiceClient,
  userStrengthRatios: StrengthRatioForMuscleGroups,
) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: STRENGTH_ASSESSMENT_COMPLETED_LOADING,
        payload: {
          shouldRefreshSteps: true,
        },
      });
      await userServiceClient.completeStrengthAssessment(
        userStrengthRatios,
      );
      dispatch({ type: STRENGTH_ASSESSMENT_COMPLETED_SUCCESS, payload: { userStrengthRatios } });
      await refreshStrengthAssessmentConig(dispatch, userServiceClient);
    } catch (e) {
      dispatch({
        type: STRENGTH_ASSESSMENT_COMPLETED_FAILURE,
        payload: {
          error: 'Failed to save assessment results',
        },
      });
    }
  };
};
